/**
 * Historical Timeline Block
 * Mobile: Accordion behavior - click year/dot to toggle content
 * Desktop: Always show all content
 * Also clones active content to a separate mobile area
 */
export function HistoricalTimeline(element) {
    const isMobile = () => window.innerWidth < 768;
    const items = element.querySelectorAll("[data-historical-item]");
    if (!items.length)
        return () => { };
    const cloneTargetSelector = element.getAttribute("data-clone-target");
    const cloneSourceSelector = element.getAttribute("data-clone-source") || "[data-historical-content]";
    const cloneTarget = cloneTargetSelector
        ? element.parentElement?.querySelector(cloneTargetSelector) ||
            document.querySelector(cloneTargetSelector)
        : null;
    const cloneActiveContent = (activeItem) => {
        if (!cloneTarget || !isMobile())
            return;
        const sourceContent = activeItem.querySelector(cloneSourceSelector);
        if (sourceContent) {
            cloneTarget.innerHTML = "";
            const clonedContent = sourceContent.cloneNode(true);
            clonedContent.classList.remove("hidden");
            cloneTarget.appendChild(clonedContent);
        }
    };
    const setInitialActive = () => {
        if (isMobile() && items.length > 0) {
            const firstItem = items[0];
            firstItem.setAttribute("data-active", "true");
            cloneActiveContent(firstItem);
        }
    };
    const handleItemClick = (clickedItem) => {
        if (!isMobile())
            return;
        const isActive = clickedItem.getAttribute("data-active") === "true";
        if (isActive)
            return;
        items.forEach((item) => {
            item.setAttribute("data-active", "false");
        });
        clickedItem.setAttribute("data-active", "true");
        cloneActiveContent(clickedItem);
    };
    const clickHandlers = new Map();
    items.forEach((item) => {
        const handler = () => handleItemClick(item);
        clickHandlers.set(item, handler);
        item.addEventListener("click", handler);
    });
    setInitialActive();
    return () => {
        items.forEach((item) => {
            const handler = clickHandlers.get(item);
            if (handler) {
                item.removeEventListener("click", handler);
            }
        });
        clickHandlers.clear();
    };
}
